import { Box, Button, IconButton } from '@mui/material';
import { useLocale } from '@koopajs/react';
import { TextField } from 'components/temp/TextFieldTemp';
import { DateTimePicker } from 'components/temp/DateTimePickerTemp';
import { ICommittee } from 'types';
import { SelectTemp } from 'components/temp/SelectTemp';
import { DocumentList } from 'components/DocumentList';
import { DeleteOutline as DeleteOutlineIcon } from '@mui/icons-material';

interface IUploadedMinuteCardProps {
  committees: ICommittee[];
  uploadedMinuteId?: string;
  handleDeleteUploadedMinute?: () => void;
  isProcessing: boolean;
}
export const UploadedMinuteCardEditable: React.FC<IUploadedMinuteCardProps> = (props) => {
  const { committees, uploadedMinuteId, handleDeleteUploadedMinute, isProcessing } = props;
  const { t } = useLocale();
  const keyPrefix = 'UploadedMinutes.UploadedMinutesCard.Form';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }} data-cy="uploaded-minute-card-editable">
      <Box sx={{ display: 'flex', gap: { xs: 0, md: 3 }, flexDirection: { xs: 'column', md: 'row' } }}>
        <DateTimePicker
          name="startDateTime"
          i18n={{ keyPrefix: keyPrefix + '.FieldDate' }}
          type="date"
          inputProps={{ min: '2000-01-01', max: '2099-12-31' }}
          validationRules={{
            pattern: /^[2]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/g
          }}
          sx={{
            '& .MuiInputBase-input': {
              backgroundColor: 'white'
            }
          }}
        />
        <SelectTemp
          name="committeeId"
          i18n={{ keyPrefix: keyPrefix + '.FieldCommitteeType' }}
          options={committees
            ?.sort((committeeA, committeeB) => {
              return committeeA.name > committeeB.name ? 1 : -1;
            })
            .map((committee) => ({
              id: committee.id,
              label: committee.name
            }))}
        />
      </Box>
      <TextField
        name="title"
        validationRules={{ maxLength: 100 }}
        i18n={{ keyPrefix: keyPrefix + '.FieldTitle' }}
      />

      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        {handleDeleteUploadedMinute && (
          <IconButton
            onClick={handleDeleteUploadedMinute}
            data-cy="uploaded-minute-card-editable_delete-button"
            disabled={isProcessing}
            sx={{ mr: 2 }}
          >
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        )}

        <Button
          type="submit"
          variant="contained"
          sx={{ alignSelf: 'flex-end' }}
          disabled={isProcessing}
          data-cy="uploaded-minute-card-editable_save-button"
        >
          {t('common:labelSave')}
        </Button>
      </Box>

      {uploadedMinuteId && (
        <DocumentList
          path={`/uploaded-minutes/${uploadedMinuteId}/documents`}
          isEditable={uploadedMinuteId ? true : false}
          isAccordion={true}
          accordionOptions={{ documentsVisible: 2 }}
          sxDocument={{ display: 'flex' }}
        />
      )}
    </Box>
  );
};
